export default class CourseAdvancedSearch {
    constructor(
        public id?: number,
        public categoryName?: string,
        public provider?: string,
        public program_id?: number,
        public tp_mycoid?: number,
        public name?: string,
        public training_start_date?: string,
        public training_end_date?: string,
        public training_hours?: number,
        public training_certification?: number,
        public training_mode?: string,
        public training_type?: string,
        public skill_areas?: string,
        public training_state?: string,
        public training_fee?: number,
        public training_allowance?: number,
        public training_provider?: string,
        public logo?: string,
    ){}
}